import React, { useState, useEffect } from "react";

import { trackPromise } from "react-promise-tracker";
import services from "../../services";
import Header from "../../components/Header";
import "./styles.scss";
import "swiper/swiper-bundle.min.css";
import "swiper/swiper.min.css";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import { getListagemBanner } from "../../services/http/bannersServico";
import iconLixeiraListagemSvg from "../../assets/icons/iconLixeiraListagem.svg";
import infoPastaSvg from "../../assets/icons/infoPasta.svg";
import { getIconesExtensao, validarVisualizar } from "../../services/utils";
import iconDownloadCard from "../../assets/icons/iconDownloadCard.svg";
import menuCompartilhar from "../../assets/iconsMenu/menuCompartilhar.svg";
import iconRecentesNovoSvg from "../../assets/icons/iconRecentesNovo.svg";
import restaurado from "../../assets/icons/restaurado.svg";
import iconLink from "../../assets/icons/iconLink.svg";
import menuCopiarCard from "../../assets/icons/menuCopiarCard.svg";
import iconButtonRestaurar from "../../assets/icons/iconButtonRestaurar.svg";
import iconRecentesAlterado from "../../assets/icons/iconRecentesAlterado.svg";
import iconRecentesAlteradoSvg from "../../assets/icons/iconRecentesAlterado.svg";
import iconVisualizar from "../../assets/icons/olho.svg";
import copiar from "../../assets/icons/copiar.svg";
import favorito from "../../assets/icons/favoritos.png";
import estrela from "../../assets/icons/iconEstrela.svg";
import { listarAtividadesRecentes } from "../../services/http/atividadeRecenteService";
import { Avatar, Menu, message } from "antd";
import ExpandCircleDownIcon from "@mui/icons-material/ExpandCircleDown";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import IconeArquivos from "../../components/IconeArquivos";
import DraftsIcon from "@mui/icons-material/Drafts";
import MarkunreadIcon from "@mui/icons-material/Markunread";
import {
  deletarNotificacoes,
  listarNotificacoes,
  listarTitulosNotificacoes,
  marcarComoLida,
} from "../../services/http/notificacoesService";
import lang from "../../assets/idioma/idiomas";
export default function PageHome() {
  const [data, setData] = useState([]);
  const [listaNotificacoes, setlistaNotificacoes] = useState([]);
  const [excluirNotificacao, setExcluirNotificacao] = useState("");
  const [detalheNotificacao, setDetalheNotificacao] = useState("");
  const [qtdNotificacoes, setQtdNotificacoes] = useState(0);
  const [dois, setDois] = useState(null);
  const { IdUser, IsAdmin } = services.storage.getUser();
  const [banners, setBanners] = useState([]);
  const listaBanners = () => {
    trackPromise(
      getListagemBanner()
        .then((res) => {
          if (!res.fail && res.data) {
            setBanners([...res.data]);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };

  const handleListarAtividadeRecentes = (pagina = 1) => {
    trackPromise(
      listarAtividadesRecentes(pagina, 10)
        .then((res) => {
          if (!res.fail && res.data) {
            setData(res.data);
          }
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  const showIniciais = (nome) => {
    if (!nome) {
      return "";
    }

    let nomecompleto = nome.replace(".", " ");
    var iniciais = nomecompleto.match(/\b(\w)/gi);

    if (iniciais == null) {
      return "";
    }

    var sobrenomes = iniciais.splice(0, iniciais.length).join("").toUpperCase();
    return sobrenomes;
  };

  const preImagemArquivo = (item) => {
    const extensao = item.extensao ?? item.nome.split(".")[1];

    let nomeArquivo =
      !item.nome?.includes(".") && extensao != null
        ? `${item.nome}.${extensao}`
        : item.nome;

    if (item.urlPreview) {
      return (
        <div>
          <img
            src={item.urlPreview}
            style={{
              width: 112,
              height: 112,
            }}
          />
        </div>
      );
    } else {
      return (
        <img
          src={getIconesExtensao(extensao)}
          style={{
            maxHeight: "1.5rem",
            maxWidth: "1.5rem",
            marginRight: "5px",
          }}
        />
      );
    }
  };
  const imagemNovoAlteradoExcluido = (descricao) => {
    if (String(descricao).includes("restaurado")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={restaurado} />
      );
    }
    if (String(descricao).includes("obter link")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={iconLink} />
      );
    }
    if (String(descricao).includes("compartilhar")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={menuCompartilhar}
        />
      );
    }
    if (String(descricao).includes("download")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconDownloadCard}
        />
      );
    }
    if (
      String(descricao).includes("copiar pasta") ||
      String(descricao).includes("copiar arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={menuCopiarCard}
        />
      );
    }
    if (
      String(descricao).includes("mover pasta") ||
      String(descricao).includes("mover arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconButtonRestaurar}
        />
      );
    }
    if (
      String(descricao).includes("editar pasta") ||
      String(descricao).includes("editar permissão") ||
      String(descricao).includes("editar arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlterado}
        />
      );
    }
    if (String(descricao).includes("visualizar")) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconVisualizar}
        />
      );
    }
    if (
      String(descricao).includes("renomear pasta") ||
      String(descricao).includes("renomear arquivo")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlterado}
        />
      );
    }
    if (
      String(descricao).includes("novo") ||
      String(descricao).includes("nova")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesNovoSvg}
        />
      );
    }

    if (
      String(descricao).includes("alterado") ||
      String(descricao).includes("alterada")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconRecentesAlteradoSvg}
        />
      );
    }

    if (
      String(descricao).includes("excluido") ||
      String(descricao).includes("exclusão de arquivo") ||
      String(descricao).includes("exclusão de pasta")
    ) {
      return (
        <img
          style={{ width: "1.5rem", height: "1.5rem" }}
          src={iconLixeiraListagemSvg}
        />
      );
    }
    if (
      String(descricao).includes("copiar pasta") ||
      String(descricao).includes("copiar pasta")
    ) {
      return <img style={{ width: "1.5rem", height: "1.5rem" }} src={copiar} />;
    }
    if (
      String(descricao).includes("favoritar arquivo") ||
      String(descricao).includes("favoritar pasta")
    ) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={favorito} />
      );
    }
    if (String(descricao).includes("editar classificação")) {
      return (
        <img style={{ width: "1.5rem", height: "1.5rem" }} src={estrela} />
      );
    }
  };
  function transformaData(inputData) {
    const dataEnvio = new Date(inputData);
    // Obtém a data e hora atuais com o ajuste de fuso horário
    const agora = new Date(
      new Date().toLocaleString("en-US", { timeZone: "UTC" })
    );
    const diferencaTempo = agora - dataEnvio;

    if (diferencaTempo < 23 * 60 * 60 * 1000) {
      return `${tempoPassado(diferencaTempo)}`;
    } else if (diferencaTempo < 24 * 60 * 60 * 1000) {
      return `${formatarHora(dataEnvio)}`;
    } else if (diferencaTempo < 7 * 24 * 60 * 60 * 1000) {
      return `${Math.floor(diferencaTempo / (24 * 60 * 60 * 1000))} d`;
    } else {
      return `${formatarDataHora(dataEnvio)}`;
    }
  }
  const linkNot = (link) => {
    window.open(link, "_blank");
  };
  const fnDeletarNotificacoes = (id) => {
    setDois(false);
    trackPromise(
      deletarNotificacoes(id)
        .then((res) => {
          listaNotificacoesSino();
          setExcluirNotificacao("");
          message.success(lang.Notificacao_deletada_com_sucesso);
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  function formatarHora(data) {
    return `${("0" + (data.getHours() - 3)).slice(-2)}:${(
      "0" + data.getMinutes()
    ).slice(-2)}`;
  }

  function formatarDataHora(data) {
    return `${("0" + data.getDate()).slice(-2)}/${(
      "0" +
      (data.getMonth() + 1)
    ).slice(-2)} - ${formatarHora(data)}`;
  }
  function tempoPassado(diferenca) {
    const minutos = Math.floor(diferenca / (60 * 1000));

    if (minutos < 60) {
      return `${minutos} min`;
    } else if (minutos < 120) {
      return "1h";
    } else {
      const horas = Math.floor(minutos / 60);
      return `${horas} h`;
    }
  }
  const listaNotificacoesSino = () => {
    trackPromise(
      listarTitulosNotificacoes(IdUser)
        .then((res) => {
          if (!res.fail && res.data) {
            setlistaNotificacoes(res.data);
            const naoVisualizadas = res.data.filter(
              (notificacao) => !notificacao.visualizado
            );

            setQtdNotificacoes(naoVisualizadas.length);
          }

          // setNovaEdit(false);
        })
        .catch((error) => {
          console.error(error);
          // setlistaNotificacoes([{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'},{link:'www.google.com',visualizado:false, titulo:'google'}]);
        })
    );
  };
  const fnMarcarComoLida = (id) => {
    setDois(false);
    trackPromise(
      marcarComoLida(id)
        .then((res) => {
          listaNotificacoesSino();
        })
        .catch((error) => {
          console.error(error);
        })
    );
  };
  useEffect(() => {
    listaNotificacoesSino();
    listaBanners();
    handleListarAtividadeRecentes();
  }, []);
  return (
    <div className="home-banners-page">
      <Header style={{ marginBottom: "2rem" }} mostrarPesquisar={false} />

      <div className="container">
        <Swiper
          autoplay={100}
          navigation={true}
          pagination={true}
          keyboard={true}
          modules={[Navigation, Pagination]}
          className="mySwiper"
        >
          {banners?.map((e, i) => (
            <SwiperSlide key={i}>
              <a href={e.link} target="_blank">
                <img width={"100%"} src={e.urlArquivo} />
              </a>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <h2 className="home-section-title">
              {lang.Atividades_Recentes}
            </h2>

            {data?.lista?.length > 0 ? (
              data?.lista?.map((item, i) => (
                <div key={i}>
                  {item?.atividadesRecentes?.map(
                    (atividade, index) =>
                      index <= 2 && (
                        <div key={index} className="atividade-card">
                            <div className="atividade-timestamp">
                              {transformaData(atividade.dataAlteracao)}
                            </div>

                            <div className="atividade-content">
                              <div className="atividade-icon p-2">
                                {atividade.tipo == 0 ? (
                                  <img src={infoPastaSvg} />
                                ) : (
                                  preImagemArquivo(atividade)
                                )}
                              </div>
                              <div className="atividade-details">
                                <div className="atividade-descricao">
                                  {imagemNovoAlteradoExcluido(
                                    String(
                                      atividade.descricaoAtividade
                                    ).toLowerCase()
                                  )}
                                  <span>
                                    {atividade.descricaoAtividade}
                                  </span>
                                </div>
                                <div className="atividade-autor">
                                  <Avatar
                                    size={"small"}
                                    style={{
                                      background: "#828282",
                                      color: "#FFFFFF",
                                    }}
                                  >
                                    {showIniciais(atividade.autor)}
                                  </Avatar>
                                  <span>
                                    {atividade.autor}
                                  </span>
                                </div>
                                <div className="atividade-documento">
                                  {atividade.tipo == 0 ? (
                                    <img
                                      src={infoPastaSvg}
                                    />
                                  ) : (
                                    <IconeArquivos
                                      tamanho={"P"}
                                      tipo={
                                        String(atividade.nomeDocumento).split(
                                          "."
                                        )[1]
                                      }
                                    />
                                  )}
                                  <span>
                                    {atividade.nomeDocumento}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                      )
                  )}
                </div>
              ))
            ) : (
              <div className="lista-vazia">{lang.Lista_vazia}</div>
            )}
          </div>

          <div className="col-md-6">
            <h2 className="home-section-title">{lang.Ultimas_Notificacoes}</h2>
            {listaNotificacoes?.length > 0 ? (
              listaNotificacoes && (
                <div>
                  {listaNotificacoes &&
                    listaNotificacoes.map((notificacao, index) =>
                      notificacao.id === excluirNotificacao ? (
                        <div className="notificacao-delete-confirm" key={index}>
                          <div className="delete-confirm-title">
                            {lang.Deseja_realmente_excluir_a_notificacao}
                          </div>
                          <div className="delete-confirm-actions">
                            <button
                              className="btn-cancel"
                              onClick={(e) => {
                                e.stopPropagation();
                                setExcluirNotificacao("");
                              }}
                            >
                              {lang.Nao}
                            </button>
                            <button
                              className="btn-confirm"
                              onClick={(e) => {
                                e.stopPropagation();
                                fnDeletarNotificacoes(notificacao.id);
                              }}
                            >
                              {lang.Sim}
                            </button>
                          </div>
                        </div>
                      ) : (
                        <div
                          className={`notificacao-card ${
                            !notificacao.visualizado ? "notificacao-nao-lida" : ""
                          } ${
                            notificacao.link == null ||
                            notificacao.link == "" ||
                            notificacao.link == undefined
                              ? "notificacao-sem-link"
                              : ""
                          }`}
                          key={index}
                          onClick={(e) => {
                            if (
                              notificacao.link !== null &&
                              notificacao.link !== "" &&
                              notificacao.link !== undefined
                            ) {
                              linkNot(notificacao.link);
                            }
                          }}
                        >
                          <div className="notificacao-timestamp">
                            {transformaData(notificacao.dataEnvioUtc)}
                          </div>
                          <div className="notificacao-header">
                            <div
                              className={`notificacao-titulo-wrapper ${
                                notificacao.visualizado ? "notificacao-lida" : ""
                              }`}
                            >
                              <div className="notificacao-icone">
                                {notificacao.visualizado ? (
                                  <DraftsIcon />
                                ) : (
                                  <MarkunreadIcon />
                                )}
                              </div>
                              <div className="notificacao-titulo">
                                {notificacao.titulo}
                              </div>
                            </div>
                            <div
                              className="notificacao-delete"
                              onClick={(e) => {
                                e.stopPropagation();
                                setExcluirNotificacao(notificacao.id);
                              }}
                            >
                              <HighlightOffIcon />
                            </div>
                          </div>
                          <div className="notificacao-body">
                            <div
                              className={`notificacao-subtitulo ${
                                notificacao.id === detalheNotificacao
                                  ? "expandido"
                                  : "recolhido"
                              }`}
                            >
                              {notificacao.subtitulo}
                            </div>
                            <div
                              className={`notificacao-expand ${
                                notificacao.id === detalheNotificacao
                                  ? "expandido"
                                  : ""
                              }`}
                              onClick={(e) => {
                                e.stopPropagation();
                                setDetalheNotificacao(
                                  notificacao.id !== detalheNotificacao
                                    ? notificacao.id
                                    : ""
                                );
                                if (notificacao.visualizado == false) {
                                  fnMarcarComoLida(notificacao.id);
                                }

                                const newNotificacoes = [
                                  ...listaNotificacoes,
                                ];
                                newNotificacoes[index].verDetalhe =
                                  !newNotificacoes[index].verDetalhe;
                                setlistaNotificacoes(newNotificacoes);
                              }}
                            >
                              <ExpandCircleDownIcon />
                            </div>
                          </div>
                        </div>
                      )
                    )}
                </div>
              )
            ) : (
              <div className="lista-vazia">{lang.Lista_vazia}</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
